import { render } from "./HeaderLayout.vue?vue&type=template&id=3ae115cb&scoped=true"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import "./HeaderLayout.vue?vue&type=style&index=0&id=3ae115cb&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae115cb"]])

export default __exports__